/* eslint-disable @angular-eslint/use-lifecycle-interface */
/* eslint-disable no-var */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @angular-eslint/no-empty-lifecycle-method */

import {merge as observableMerge,  Observable ,  Subscription } from 'rxjs';

import {take, first,  filter, tap } from 'rxjs/operators';
import { ILoggedHomeAppState } from '@hub-workspace/apps/logged-home/src/app/shared/interfaces/logged-home-app-state.interface';
import { LoginChallengeResult } from '@toro/common/shared/models/authentication/login.challenge.result';
import {
  webAppTokenQueryParamName,
  webAppLoginRedirectParamName
} from '@toro/common/shared/resources/consts';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { LoginWraperService } from '@toro/common/shared/services/login.wraper.service';
import { UsersEffects } from '@toro/common/shared/state-management/users/users.effects';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { UsersState } from '@toro/common/shared/state-management/users/users.reducer';
import { UsersAction } from '@toro/common/shared/state-management/users/users.actions';
import { TextUtils } from '@toro/common/shared/resources/text.utils';
import { SettingsService } from '@toro/common/shared/services/settings/settings.service';
import { SuitabilityProfilesEnum } from '@toro/common/shared/enum/suitability/suitability-profiles.enum';
import { BackendRegistationStatus } from '@toro/common/shared/enum/backend-registration-status.enum';
import { DialogsService } from '@toro/common/shared/services/dialogs.service';
import { SentryService } from '@toro/common/shared/services/sentry/sentry.service';
import { environment } from '@hub-workspace/apps/logged-home/src/environments/environment';
import { NavigationService } from '@toro/common/shared/services/navigation/navigation.service';
import { AppcuesOnboardingObserver } from '@toro/common/shared/services/appcues/ng/observer.service';
import { BlipSacEventsTrigger } from '@toro/common/shared/components/chat-blip/blip-sac-events-trigger';
import { ImportedBy } from '@toro/common/shared/enum/user/importedby';
import { CustomerWalletAction } from './state-management/customer-wallet/customer-wallet.action';
import { OneViewPermissionsAction } from './state-management/one-view-permissions/one-view-permissions.action';
import { ICustomerWallet } from './shared/modules/customer-wallet/interfaces/customer-wallet.interface';
import { StorageService } from '@toro/common/shared/services/storage.service';

const { version: appVersion } = require('../../../../package.json');

const { version: commonPackageVersion } = require('@toro/common/package.json');

declare var $: any;

@AutoUnsubscribe()
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnDestroy, OnInit {
  public user$: Observable<UsersState>;
  public userAuth: any;
  public loginInProgress: boolean; // Login disparado pelo componente local está em progresso
  public userSubscription: Subscription;
  public userLoginSubscription: Subscription;
  public userWebAppLoading: Subscription;
  public succefulyLoginSubscription: Subscription;
  public webAppLoading: boolean = false;
  private blipSacEventsTrigger: BlipSacEventsTrigger;
  public wallet: ICustomerWallet;
  public isLoaded: boolean;

  constructor(
    private router: Router,
    private store: Store<AppState>,
    private loggedStore: Store<ILoggedHomeAppState>,
    private activatedRoute: ActivatedRoute,
    private usersEffects: UsersEffects,
    private loginWraperService: LoginWraperService,
    private settingsService: SettingsService,
    private textUtils: TextUtils,
    private navigationService: NavigationService,
    private dialogsService: DialogsService,
    private sentryService: SentryService,
    private appcuesOnboardingObserver: AppcuesOnboardingObserver
  ) {
    this.user$ = this.store.select(s => s.authentication);
    this.textUtils.extendStringPrototype();
    this.blipSacEventsTrigger = new BlipSacEventsTrigger();
  }

  public initializeSentry() {
    // Iniciar tracking de erros com sentry para toda a aplicação de cadastro

    this.sentryService.initWithOptions({
      dsn:
        'https://ff355b02e1b14884b6216bd3750f2da2@sentry.toroinvestimentos.com.br/42',
      environment: this.settingsService.getEnvironment(),
      enabled: environment.production,
      release: appVersion,
      sampleRate: 0.05 //Apenas 5% dos erros apenas para validar os mais recorrentes por enquanto
    });
  }

  public ngOnInit() {
    // Carregar configurações primeiro usando then/catch
    this.settingsService.loadEnvironmentSettings()
      .then(() => {
        this.continueInitialization();
      })
      .catch((error) => {
        console.error('[AppComponent] Failed to load settings:', error);
        // Continuar mesmo com erro
        this.continueInitialization();
      });
  }

  private continueInitialization() {
    this.settingsService.setAppVersion(appVersion);
    this.settingsService.setCommonPackageVersion(commonPackageVersion);
    this.initializeListeners();

    // Pega todos os erros de rotas e envia para o Hub resolver
    this.navigationService.handleNavigationError();

    this.initializeSentry();
    // Query params
    const params = {
      ...this.activatedRoute.snapshot.queryParams
    };
    const token = params[webAppTokenQueryParamName];
    const redirectUri = params[webAppLoginRedirectParamName];

    this.store.dispatch({ type: OneViewPermissionsAction.getOneViewPermissions });

    this.loggedStore
      .select(state => state.customerWallet)
      .pipe(
        tap(({ wallet, pending, isLoaded }) => {
          if (!wallet && !pending && !isLoaded) {
            this.store.dispatch({
              type: CustomerWalletAction.getCustomerWallet
            });
          }

          if (wallet) {
            this.wallet = wallet;
            this.isLoaded = isLoaded;
            this.userAccountLevel(wallet);
          }

          if (!pending) {
            this.isLoaded = isLoaded;
          }
        }),
        filter(({ isLoaded }) => isLoaded)
      )
      .subscribe();

    // Solicita o login caso o token tenha sido informado via url (token complexo)
    if (token && this.wallet) {
      // Loading quando for webapp
      this.webAppLoading = true;

      // Login via token do webapp
      this.callLoginTokenApp(redirectUri);

      // Verifica se os effects de login foram chamados
      this.userWebAppLoading = observableMerge(
        this.usersEffects.authenticateUserUsingTokenTimeFromWebApp$.pipe(filter(a =>
          a.type.equals(UsersAction.loginSuccess)
        )),
        this.usersEffects.authenticateUserUsingTokenTimeFromWebApp$.pipe(filter(a =>
          a.type.equals(UsersAction.loginError)
        ))
      ).subscribe(data => {
        this.setValueToWebAppLoading();
      });

      this.loginInProgress = true;
      this.store.dispatch({
        type: UsersAction.authenticateUserUsingTokenFromWebApp,
        payload: token
      });

      // Remover parâmetros da url
      delete params[webAppTokenQueryParamName];
      delete params[webAppLoginRedirectParamName];

      // Url sem os parâmetros
      const uri = `${this.router.url}`.replace(/\?.*/, '');
      this.router.navigate([uri], { queryParams: params });
    } else {
      // Redirecionamento solicitado (se há uma url)
      this.redirectUser(redirectUri);
    }

    this.userSubscription = this.user$.subscribe(userAuth => {
      this.userAuth = userAuth;
    });

    this.blipSacEventsTrigger.verifyUrlAndFireEventIfNeedly();
  }

  /**
   * Redireciona o usuário caso uma url válida tenha sido informada.
   *
   * @param uri url para o redirecionamento (relativa e interna ao projeto)
   */
  public redirectUser(uri: string) {
    if (uri) {
      this.router.navigateByUrl(uri).then(a => {
        this.loginInProgress = false;
      });
    } else {
      this.loginInProgress = false;
    }
  }

  /**
   * Le quando o login esta em progresso e se der sucesso ele redireciona o usuario
   *
   * @param redirectUri url para o redirecionamento
   */
  public callLoginTokenApp(redirectUri) {
    this.userLoginSubscription = this.usersEffects.authenticateUserUsingTokenTimeFromWebApp$.pipe(
      filter(action => this.loginInProgress))
      .subscribe(action => {
        if (UsersAction.loginSuccess.equals(action.type)) {
          this.redirectUser(redirectUri);
        } else {
          // Cancel last subscription
          if (this.succefulyLoginSubscription) {
            this.succefulyLoginSubscription.unsubscribe();
          }

          // Espera o resultado do login
          this.loginWraperService.navigateToLogin({
            afterLoginRedirectTo: redirectUri
          });
        }
      });
  }

  public ngAfterViewInit() {
    this.loadScript();
  }

  private loadScript() {
    const siteKey = this.settingsService.getConfigurationKeyValue(
      'enterpriseRecaptchaSiteKey'
    );
    const node = document.createElement('script'); // creates the script tag
    node.src = `https://www.google.com/recaptcha/enterprise.js?render=${siteKey}`; // sets the source (insert url in between quotes)
    node.type = 'text/javascript'; // set the script type
    node.async = true; // makes script run asynchronously
    node.charset = 'utf-8';
    // append to head of document
    document.getElementsByTagName('head')[0].appendChild(node);
  }

  public ngAfterContentInit() {
    // Verifica se o usuário está como "Sem Perfil" no suitability
    // e lança um dialog pedindo a atualização das informações
    this.store
      .select(({ userProfile, suitability }) => ({
        userProfile,
        suitability
      })).pipe(
      filter(({ suitability }) => !!suitability.profile),

      // Filtra por usuários sem suitability completo
      filter(
        ({ suitability }) =>
          suitability.profile.profile === SuitabilityProfilesEnum.NoProfile
      ),

      // Filtra por usuários com o cadastro já completo
      filter(({ userProfile }) => {
        switch (userProfile.user.registrationStatus) {
          case BackendRegistationStatus.Canceled:
            return false;
          case BackendRegistationStatus.Filling:
            return false;
          case BackendRegistationStatus.None:
            return false;

          default:
            return true;
        }
      }),
      filter(
        ({ userProfile }) => !!userProfile.user && !!userProfile.user.cpfcnpj
      ),
      first(),)
      .subscribe(({ userProfile: { user } }) => {
        // TODO: implementação temporaria - tombamento clientes Pi
        //  --   remover '{ userProfile: { user }' e 'importedBy'
        //  --   quando todos os clieentes tiverem com agreement e suitability ok --- fernando.souza -->
        const { importedBy } = user;

        const isImportedBy =
          importedBy >= ImportedBy.Pi && importedBy <= ImportedBy.IndentifiedPi;

        if (isImportedBy) return;
      });
  }

  /**
   * Redireciona para uma rota do hub
   * @param url
   */
  public redirectExternal(url: string) {
    window.location.href = url;
  }

  /** Não remover, necessário para o funcionamento correto do @AutoUnsubscribe */
  public ngOnDestroy() {
    //
  }

  /**
   * Seta valor false para o loading do webApp.
   */
  public setValueToWebAppLoading() {
    this.webAppLoading = false;
  }

  private initializeListeners() {
    this.store
      .select(s => s.authentication).pipe(
      filter(({ currentUser }) => currentUser),
      take(1),)
      .subscribe(() => this.appcuesOnboardingObserver.listen());
  }

  /**
   * Define se o usuário é exclusivo
   *
   * @param wallet
   */
  public userAccountLevel(wallet: ICustomerWallet) {
    StorageService.setCookie(
      'hubUserExclusiveStatus',
      wallet ? 'true' : 'false'
    );
  }
}
